import React, { useEffect, useState } from "react";
import { Button, Popconfirm, Space, Table, Tag } from "antd";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { SessionDto, listSessions, revokeSession } from "../../../services/adminService";

const fmt = (v?: string | null) => (v ? dayjs(v).format("YYYY-MM-DD HH:mm") : "—");

export default function SessionsAdmin() {
  const [sessions, setSessions] = useState<SessionDto[]>([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      setSessions(await listSessions());
    } catch (e: any) {
      toast.error(e?.response?.data?.detail || "Failed to load sessions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const onRevoke = async (id: string) => {
    try {
      await revokeSession(id);
      toast.success("Session revoked");
      load();
    } catch (e: any) {
      toast.error(e?.response?.data?.detail || "Revoke failed");
    }
  };

  const columns = [
    { title: "User", dataIndex: "username", key: "username" },
    {
      title: "Status",
      key: "active",
      render: (_: any, s: SessionDto) =>
        s.active ? <Tag color="green">active</Tag> : <Tag>inactive</Tag>,
    },
    { title: "IP", dataIndex: "ip", key: "ip" },
    {
      title: "Device",
      dataIndex: "user_agent",
      key: "user_agent",
      ellipsis: true,
    },
    { title: "Created", key: "created_at", render: (_: any, s: SessionDto) => fmt(s.created_at) },
    { title: "Last used", key: "last_used_at", render: (_: any, s: SessionDto) => fmt(s.last_used_at) },
    { title: "Idle expiry", key: "expires_at", render: (_: any, s: SessionDto) => fmt(s.expires_at) },
    {
      title: "Max expiry",
      key: "absolute_expires_at",
      render: (_: any, s: SessionDto) => fmt(s.absolute_expires_at),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_: any, s: SessionDto) =>
        s.active ? (
          <Popconfirm title="Revoke this session?" onConfirm={() => onRevoke(s.id)}>
            <Button size="small" danger>
              Revoke
            </Button>
          </Popconfirm>
        ) : null,
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: 12 }}>
        <Space>
          <Button onClick={load}>Refresh</Button>
        </Space>
      </div>
      <Table rowKey="id" loading={loading} dataSource={sessions} columns={columns} pagination={{ pageSize: 10 }} />
    </div>
  );
}
